import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';

import { UiKitModule } from '../../../shared/modules/ui-kit/ui-kit.module';
import {
  DocumentoOferta,
  ProntoPagoRestitucionService,
  ResultadoConfirmacion
} from '../../../services/pronto-pago-restitucion.service';

/**
 * Último paso del flujo "Pronto Pago": RESULTADO.
 * Confirmación de "Acuerdo firmado con éxito": resumen de lo aceptado, documentos y CTA de salida.
 */
@Component({
  selector: 'app-pronto-pago-resultado',
  standalone: true,
  imports: [CommonModule, UiKitModule],
  templateUrl: './resultado.component.html',
  styleUrl: './resultado.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ResultadoComponent implements OnInit {

  @Output() salir = new EventEmitter<void>();

  resultado?: ResultadoConfirmacion;
  cargando = true;
  error = false;

  constructor(private readonly prontoPagoService: ProntoPagoRestitucionService) { }

  ngOnInit(): void {
    this.prontoPagoService.getComprobante().subscribe({
      next: resultado => {
        this.resultado = resultado;
        this.cargando = false;
      },
      error: () => {
        this.error = true;
        this.cargando = false;
      }
    });
  }

  descargarDocumento(doc: DocumentoOferta): void {
    const a = document.createElement('a');
    a.href = doc.url;
    a.target = '_blank';
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
}
